import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "@/ui/Modal/Modal";
import {
  RaffleCalendarIcon,
  RaffleChanceIcon,
  RaffleFairIcon,
  RaffleInfoIcon,
  RaffleModalCloseIcon,
} from "@/apps/raffle/pages/RafflePage/icons";
import cls from "./styles.module.scss";

export const RaffleInfoButton = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className={[cls.wheelCornerButton, cls.raffleInfoButton].join(" ")}
        onClick={() => setIsOpen(true)}
        aria-label={t("raffle.info.button")}
      >
        <RaffleInfoIcon />
        {t("raffle.info.button")}
      </button>
      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        hideHeader
        wrapperClassName={cls.raffleInfoModalWrapper}
        contentClassName={cls.raffleInfoModal}
      >
        <button
          type="button"
          className={cls.raffleInfoClose}
          onClick={() => setIsOpen(false)}
          aria-label={t("raffle.info.close")}
        >
          <RaffleModalCloseIcon />
        </button>
        <h2 className={cls.raffleInfoTitle}>{t("raffle.info.title")}</h2>
        <div className={cls.raffleInfoList}>
          <div className={cls.raffleInfoRow}>
            <span className={cls.raffleInfoIconWrap}>
              <RaffleCalendarIcon />
            </span>
            <span>{t("raffle.info.drawSchedule")}</span>
          </div>
          <div className={cls.raffleInfoRow}>
            <span className={cls.raffleInfoIconWrap}>
              <RaffleChanceIcon />
            </span>
            <span>{t("raffle.info.chance")}</span>
          </div>
        </div>
        <div className={cls.raffleInfoFairBlock}>
          <span className={cls.raffleInfoIconWrap}>
            <RaffleFairIcon />
          </span>
          <span>{t("raffle.info.fair")}</span>
        </div>
      </Modal>
    </>
  );
};
